import { GzContentControlTrafficWebComponent } from './component/GzContentControlTrafficWebComponent';

export { GzContentControlTrafficWebComponent };
